// v9 Customize Fee Structure classes (.qsec, .hint, .label, .input, .btn-*).
export const qsec = 'border border-gray-200 rounded-lg px-6 py-5 bg-white';
export const qsecTitle = 'text-[15px] font-semibold text-gray-900 mb-1';
export const qsecHint = 'text-[13px] text-gray-500 mb-3.5 max-w-[720px]';
export const qLabel = 'block text-sm font-medium text-gray-700 mb-2';
export const qInput =
	'block w-full border border-gray-300 rounded-lg bg-white px-4 py-2 text-sm leading-5 text-gray-900 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500';
export const qBtnBase =
	'inline-flex items-center justify-center gap-2 border font-medium whitespace-nowrap transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
export const qBtn = `${qBtnBase} px-4 py-2 text-sm leading-5 rounded-lg`;
export const qBtnSm = `${qBtnBase} px-3 py-1 text-xs leading-[18px] rounded-md`;
export const qBtnPrimary =
	'bg-primary-500 text-white border-transparent hover:bg-primary-600';
export const qBtnSecondary =
	'bg-white text-primary-700 border-gray-300 hover:bg-gray-50';
export const qBtnNeutral =
	'bg-white text-gray-900 border-gray-300 hover:bg-gray-100';
